import { useMemo } from "react";
import { RoutingService } from "../services/RoutingService";

export const useRoutingService = (): RoutingService => {
  const routingServiceInstance = useMemo(() => {
    RoutingService.initialize();

    return RoutingService.getRoutingServiceInstance();
  }, []);

  return routingServiceInstance;
};
